export const Config = {
  // In development environment use the REACT_BACKEND_URL env variable. In
  // production, use the `__BACKEND_URL__` placeholder. It will be substituted
  // before running the application (See 'docker/start.sh' script).
  apiUrl: process.env.VITE_BACKEND_URL || "__BACKEND_URL__",
};
